import { useUserId } from '~hooks/useUserId';
import { useApplyPromoCodeMutation } from '~services/api/credits';
import { subscriptionApi } from '~services/api/subscription';

import type { BillPeriod } from '../types';

export const useOffer = ({
	promocode,
	sku,
	skip,
}: {
	promocode: string;
	sku: string | undefined;
	skip: boolean;
}) => {
	const [
		validate,
		{
			data: validPromocode,
			isLoading: isValidationLoading,
			isSuccess: isValidationSuccess,
			isError: isValidationError,
		},
	] = useApplyPromoCodeMutation();

	const userId = useUserId();
	const { data: assignedPromocodes, isFetching } =
		subscriptionApi.useGetAssignedPromocodesQuery(
			{ userId },
			{
				skip,
				refetchOnMountOrArgChange: true,
			}
		);
	const hasPromocodeAlreadyAssigned = !!assignedPromocodes?.PromoCodes.some(
		(item) => item.Code === promocode
	);

	const offer =
		validPromocode && sku
			? (validPromocode.Prices || []).find((price) => price.Sku === sku)
			: undefined;

	const isOfferUnreliable =
		(isValidationSuccess && !offer) ||
		isValidationError ||
		hasPromocodeAlreadyAssigned;

	const billPeriod: BillPeriod | undefined = (
		[
			['.1m.', 'month'],
			['.3m.', 'quarter'],
			['.12m.', 'year'],
		] as const
	).find(([key]) => offer?.Sku.includes(key))?.[1];

	return {
		offer,
		isOfferUnreliable,
		discount: validPromocode?.DiscountPercent || NaN,
		billPeriod,
		validate,
		loading: isValidationLoading || isFetching,
	};
};
